import * as tslib_1 from "tslib";
import { MicrocreditoService } from './../../../services/microcredito.service';
import { BehaviorSubject } from 'rxjs';
import * as i0 from "@angular/core";
import * as i1 from "../../../services/microcredito.service";
export class FaefStateService {
    constructor(microcreditoService) {
        this.microcreditoService = microcreditoService;
        this.faef = new BehaviorSubject(null);
        this.faef$ = this.faef.asObservable();
    }
    init(propostaId, cliente) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.getLast() || this.getLast().proposta !== propostaId) {
                yield this.loadCache(propostaId, cliente);
            }
        });
    }
    loadCache(propostaId, cliente) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            try {
                const bd = yield this.microcreditoService.findByProposta(propostaId);
                const cache = JSON.parse(localStorage.getItem(`faef_${propostaId}`)) || { proposta: propostaId };
                this.faef.next(null);
                const faefCarregado = (bd || cache);
                if (cliente) {
                    this.microcreditoService.defineCliente(faefCarregado, cliente);
                }
                if (faefCarregado.faefVendasMedia && faefCarregado.faefVendasMedia.faefVendasMediaMes) {
                    faefCarregado.faefVendasMedia.faefVendasMediaMes
                        .forEach((media) => media.tipoMes = `${media.tipoMes}`);
                }
                this.setState(faefCarregado);
            }
            catch (error) { }
        });
    }
    getLast() {
        return this.faef.getValue();
    }
    getState() {
        return this.faef$;
    }
    setState(faefNew) {
        let faef = faefNew;
        if (this.getLast() && faef) {
            faef = Object.assign({}, this.getLast(), faef);
        }
        console.log('faef atualizado:', faef);
        localStorage.setItem(`faef_${faef.proposta}`, JSON.stringify(faef));
        this.faef.next(faef);
    }
    clear() {
        console.log('Limpando estado do faef');
        Object.getOwnPropertyNames(localStorage).filter(e => e.startsWith('faef_')).forEach(e => localStorage.removeItem(e));
        this.faef.next(null);
    }
}
FaefStateService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FaefStateService_Factory() { return new FaefStateService(i0.ɵɵinject(i1.MicrocreditoService)); }, token: FaefStateService, providedIn: "root" });
